import React, { useContext, useState } from 'react'
import { LoadingContext, NavigateContext, M_Table, BufferService } from 'src/components/M_Components'// import { M_Table } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export const CustomerAddress = ({ roles }) => {
    const [refresh, setRefresh] = useState(false)
    const bufferServiceCustomerAddress = new BufferService('CustomerAddress')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createCustomerAddress', t("CreateCustomerAddress"))
            return
        }

        let tempData = data
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null' || tempData.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('createCustomerAddress', t("EditCustomerAddress"))
            return
        }
    }


    const deleteCustomerAddress = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            tempData.forEach(obj => {
                deleteFunc(obj.Id)
            })
            return
        }
        deleteFunc(tempData.Id)
    }

    function deleteFunc(id) {
        bufferServiceCustomerAddress.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessQuoteDeleted"))
            setRefresh(true)
        })
    }

    const removeContextItems = ['View', 'Copy']

    return (
        <div className='backgroundForms'>
            < div >
                <div>
                    <M_Table
                        roleName={'CustomersAddress'}
                        filtersOnTable
                        entityName={'CustomerAddress'}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        replaceFunctions={new Map([
                            ['Delete', (data) => deleteCustomerAddress(data)],
                            ['Create', (data) => NewRoute('', '', 'create', data)],
                            ['Edit', (data) => NewRoute('', '', 'edit', data)]
                        ])}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>
        </div >
    )
}